import { ButtonHTMLAttributes } from 'react';
import { IconButton } from '@style/emotion';
import { Link } from 'react-router-dom';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  src?: string;
}

function IPFSBtn(props: Props) {
  /* Define state / hook */
  const { src } = props;

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return src ? (
    <Link
      className="mr-3"
      target="_blank"
      to={src.replace('ipfs://', 'https://ipfs.io/ipfs/')}
    >
      <IconButton className={props.className}>
        <svg
          fill="#fff"
          height="256px"
          role="img"
          stroke="#fff"
          strokeWidth="0.9600000000000002"
          viewBox="-4.8 -4.8 33.60 33.60"
          width="256px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g strokeWidth="0" />
          <g strokeLinecap="round" strokeLinejoin="round" />
          <g>
            <path d="M12 0 1.608 6v12L12 24l10.392-6V6zm-1.073 1.445h.001a1.8 1.8 0 0 0 2.138 0l7.534 4.35a1.794 1.794 0 0 0 0 .403l-7.535 4.35a1.8 1.8 0 0 0-2.137 0l-7.536-4.35a1.795 1.795 0 0 0 0-.402zM21.324 7.4c.109.08.226.147.349.201v8.7a1.8 1.8 0 0 0-1.069 1.852l-7.535 4.35a1.8 1.8 0 0 0-.349-.2l-.009-8.653a1.8 1.8 0 0 0 1.07-1.851zm-18.648.048 7.535 4.35a1.8 1.8 0 0 0 1.069 1.852v8.7c-.124.054-.24.122-.349.202l-7.535-4.35a1.8 1.8 0 0 0-1.069-1.852v-8.7a1.85 1.85 0 0 0 .35-.202z" />
          </g>
        </svg>
      </IconButton>
    </Link>
  ) : (
    <span />
  );
}

export default IPFSBtn;
